import { SideBarElementProps } from "@/common/types";
import { cn } from "@/common/utils";
import { NavLink } from "react-router";
import { motion } from "framer-motion";
import CustomTypography from "../Typography/CustomTypography";

export default function SideBarElement({
  element,
  isOpen,
  count,
}: SideBarElementProps) {
  const { icon, label, to } = element;
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn(
          "rounded-lg font-kanit px-2.5 text-base font-light w-full py-2 flex items-center justify-start transition-all",
          isActive
            ? "bg-primary text-white opacity-100"
            : "text-gray-400 opacity-60",
          !isOpen && "justify-center"
        )
      }
    >
      <div className="mr-2.5 w-[26px] h-[26px] flex items-center justify-center">
        {icon}
      </div>
      <motion.div
        initial={{ opacity: 0, width: 0, top: 0, left: 0 }}
        animate={{
          opacity: !isOpen ? 1 : 0,
          width: !isOpen ? "auto" : 0,
          top: !isOpen ? "135px" : "200px",
          left: !isOpen ? "62px" : "300px",
        }}
        transition={{ duration: 0.5 }}
        className="absolute"
      >
        {label === "Notifications feed" && !isOpen && count !== 0 && (
          <div className="rounded-full bg-[#0E98FF] flex items-center justify-center w-[28px]  p-1">
            <CustomTypography color="white">{count}</CustomTypography>
          </div>
        )}
      </motion.div>
      <motion.span
        initial={{ opacity: 0, width: 0 }}
        animate={{
          opacity: isOpen ? 1 : 0,
          width: isOpen ? "auto" : 0,
        }}
        transition={{ duration: 0.5 }}
        className="overflow-hidden truncate"
      >
        <div className="flex gap-6">
          {label}
          {label === "Notifications feed" && count !== 0 && (
            <div
              className={`rounded-full bg-[#0E98FF] flex items-center justify-center w-[28px] p-1`}
            >
              <CustomTypography color="white">{count}</CustomTypography>
            </div>
          )}
        </div>
      </motion.span>
    </NavLink>
  );
}
